import { Component, input, output } from '@angular/core';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import { DetailsComponent } from './components/details/details.component';
import { Priority } from './components/status/models/status.interfaces';
import { StatusComponent } from './components/status/status.component';
import {
  MachTier,
  MedallionBanner
} from './models/medallion-banner.interfaces';

@Component({
  selector: 'idp-medallion-banner',
  standalone: true,
  imports: [DetailsComponent, StatusComponent],
  templateUrl: './medallion-banner.component.html',
  styleUrl: './medallion-banner.component.scss'
})
export class MedallionBannerComponent {
  content = input<MedallionBanner>({} as MedallionBanner);
  redirect = output<string>();
  analytics = output<Link>();

  get360AndSkyPriority(tier: MachTier, priority: Priority) {
    return (
      (tier.name === '360' ? '--360' : '') +
      (priority.label !== '' && priority.url !== '' ? '--skypriority' : '')
    );
  }

  handleRedirect(data: Link) {
    this.redirect.emit(data.url);
    this.analytics.emit(data);
  }
}
